import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {ChangeDetectorRef, DOCUMENT, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {
    BaseSiteService,
    CmsConfig,
    ConfigModule,
    GlobalMessageService,
    I18nModule,
    NotAuthGuard,
    provideConfig,
    RoutingService,
    UrlModule,
    WindowRef,
} from '@spartacus/core';
import {FormErrorsModule, PageSlotModule, SpinnerModule} from '@spartacus/storefront';
import {LoginFormComponentService, LoginFormModule} from '@spartacus/user/account/components';

import {AimoAuthRedirectService} from '../../../service/auth/aimo-auth-redirect.service';
import {AimoInputModule} from '../../../shared/input/aimo-input.module';

import {AimoLoginFormComponentService} from './aimo-login-form-component.service';
import {AimoLoginFormComponent} from './aimo-login-form.component';
import {AimoProcessCdcLoginComponent} from './aimo-process-cdc-login.component';
import {AimoSpinnerModule} from "../../shared/spinner/aimo-spinner.module";
import {Actions} from "@ngrx/effects";
import {AimoRoutingService} from "../../../cms-structure/routing/aimo-routing.service";
import {AimoAuthService} from "../../../service/auth/aimo-auth.service";
import {AimoNavigationService} from "../../../service/navigation/aimo-navigation.service";
import {AimoLogoutComponent} from "./aimo-logout.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        SpinnerModule,
        AimoInputModule,
        PageSlotModule,

        ConfigModule.withConfig({
            routing: {
                routes: {
                    processLogin: {
                        paths: ['login/process'],
                        protected: false
                    },
                    logout: {
                        paths: ['logout'],
                        protected: false
                    }
                }
            },
        }),
        AimoSpinnerModule
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                ReturningCustomerLoginComponent: {
                    component: AimoLoginFormComponent,
                    guards: [NotAuthGuard],
                    providers: [
                        {
                            provide: LoginFormComponentService,
                            useClass: AimoLoginFormComponentService,
                            deps: [
                                AimoAuthService,
                                GlobalMessageService,
                                WindowRef,
                                RoutingService,
                                AimoAuthRedirectService,
                                BaseSiteService,
                                DOCUMENT,
                                HttpClient
                            ],
                        },
                    ],
                },
                AimoProcessCdcLoginComponent: {
                    component: AimoProcessCdcLoginComponent,
                    providers: [
                        {
                            provide: LoginFormComponentService,
                            useClass: AimoLoginFormComponentService,
                            deps: [
                                AimoAuthService,
                                RoutingService,
                                ActivatedRoute,
                                Actions,
                                Router,
                                ChangeDetectorRef,
                                AimoRoutingService,
                                AimoNavigationService,
                                DOCUMENT,
                            ],
                        },
                    ],
                },
                AimoLogoutComponent: {
                    component: AimoLogoutComponent
                },
            },
        })
    ],
    declarations: [AimoLoginFormComponent, AimoProcessCdcLoginComponent, AimoLogoutComponent],
})
export class AimoLoginFormModule extends LoginFormModule {
}
